export enum Crm {
  salesforce = 'salesforce',
  hubspot = 'hubspot',
}

export const CrmDisplayName = {
  [Crm.salesforce]: 'Salesforce',
  [Crm.hubspot]: 'HubSpot',
};

export type CrmExportLimit = {
  contactsLimit: number;
  leadsLimit: number;
};

export type CrmStatus = {
  isAccountExportEnabled: boolean;
  isContactExportEnabled: boolean;
  isCurrentUserVerifiedByCrm: boolean;
  isLeadExportEnabled?: boolean;
  crmExportLimit: CrmExportLimit;
  isCrmLabelsEnabled: boolean;
  isCrmFeedEnabled: boolean;
};

export type ContactToExport = {
  contactId: string;
  domain: string;
  accountId?: string;
};

export type ContactsToExportPayload = {
  countries: number[];
  contacts: ContactToExport[];
};

export type LeadToExport = {
  contactId: string;
  domain: string;
};

export type LeadsToExportPayload = {
  countries: number[];
  leads: LeadToExport[];
};

export type ExportToCrmReturn = {
  totalRecords: number;
  cleanedRecords: number;
  inProgressRecords: number;
  processedRecords: number;
  failedRecords: number;
  failedRecordsByType: Record<string, number>;
  succeededLinks: {
    externalLink: string;
    similarwebId: string;
  }[];
  exportHistoryUrl?: string;
};

export type CrmAccount = {
  id: string;
  domain?: string;
  name?: string;
  favicon?: string;
  isCurrentAccount?: boolean;
  crmAccountUrl?: string;
  ownerName?: string;
};

export type ContactToExportPreview = {
  isExistAsLead?: true;
  contactId: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  accountName: string;
  accountDomain: string;
  matchedCompanies: CrmAccount[];
};

export type ContactsToExportPreviewReturn = ContactToExportPreview[];

export type NextPage = {
  after: number;
};

export type CrmSearchAccountsReturn = {
  data: CrmAccount[];
  next: NextPage;
};

export type DomainToExportPayload = {
  countries: number[];
  domains: string[];
};
